import recoverClient from "../recoverClient";
import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button, FormGroup, HGrid, Input, VGrid, tombac } from 'tombac';
import isEmail from 'validator/lib/isEmail';
import { object, string } from 'yup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormLayout = styled(VGrid).withConfig({
  displayName: "ForgotPasswordForm__FormLayout"
})(["justify-content:stretch;max-width:", ";"], tombac.unit(540));
const validationSchema = object({
  email: string().ensure().trim().required('This field is required.').test({
    name: 'email',
    message: 'This field must contain a valid email address.',
    test: value => value !== '' && isEmail(value)
  })
});
export const ForgotPasswordForm = ({
  onSuccess
}) => {
  const formik = useFormik({
    initialValues: {
      email: ''
    },
    async onSubmit({
      email
    }) {
      await recoverClient.resetPassword(email);
      if (onSuccess) {
        onSuccess();
      }
    },
    validateOnMount: true,
    validationSchema
  });
  const getFormGroupProps = name => ({
    caption: formik.touched[name] && formik.errors[name],
    danger: Boolean(formik.touched[name] && formik.errors[name])
  });
  const getInputProps = name => ({
    invalid: Boolean(formik.touched[name] && formik.errors[name]),
    name,
    ...formik.getFieldProps(name)
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: formik.handleSubmit,
    "data-sentry-component": "ForgotPasswordForm",
    "data-sentry-source-file": "ForgotPasswordForm.tsx",
    children: [/*#__PURE__*/_jsx(FormLayout, {
      "data-sentry-element": "FormLayout",
      "data-sentry-source-file": "ForgotPasswordForm.tsx",
      "data-sentry-element": "FormLayout",
      children: /*#__PURE__*/_jsx(FormGroup, {
        htmlFor: "email-input",
        label: "Your e-mail address",
        ...getFormGroupProps('email'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "ForgotPasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          id: "email-input",
          ...getInputProps('email'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "ForgotPasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      })
    }), /*#__PURE__*/_jsxs(HGrid, {
      $mt: "3sp",
      "data-sentry-element": "HGrid",
      "data-sentry-source-file": "ForgotPasswordForm.tsx",
      "data-sentry-element": "HGrid",
      children: [/*#__PURE__*/_jsx(Button, {
        busy: formik.isSubmitting,
        disabled: !formik.isValid,
        type: "submit",
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "ForgotPasswordForm.tsx",
        "data-sentry-element": "Button",
        children: "Request reset link"
      }), /*#__PURE__*/_jsx(Button, {
        as: Link,
        to: "/login",
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "ForgotPasswordForm.tsx",
        "data-sentry-element": "Button",
        children: "Back to sign in"
      })]
    })]
  });
};